import React from 'react';
import styles from './Announcements.module.scss';
import google from '@app/img/onboarding/google.svg';
import microsoft from '@app/img/onboarding/msft.svg';
import linkedin from '@app/img/onboarding/linkedin.svg';
import messages from '@app/img/onboarding/msg.svg';
import contacts from '@app/img/onboarding/contacts.svg';
import facebook from '@app/img/onboarding/facebook.svg';
import twitter from '@app/img/onboarding/twitter.svg';

const integrationLogos = [google, microsoft, facebook, linkedin, messages, twitter, contacts];

export default function ConnectIntegrations() {
  return (
    <>
      <div className={styles.integrationsList}>
        {integrationLogos.map((logo, idx) => (
          <img src={logo} key={idx} />
        ))}
      </div>
    </>
  );
}
